import { spacing } from '@constants/spacing';
import { baseUrl, knowledgeBase, raiseTicket } from '@constants/URLs';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUserHasRole } from '@hooks/useUserHasRole';
import { Box, Divider, styled } from '@mui/material';
import { useTenant } from '@providers/Tenant';
import { t } from 'i18next';
import { allowedRoles, StyledA } from './shared';

const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.xSmallSpacing};
`;

const StyledLink = styled('a')`
  display: flex;
  align-items: center;
  gap: ${spacing.xSmallSpacing};
  text-decoration: underline;
  ${({ theme }) => `
    font-size: ${theme.typography.body2.fontSize}
    font-weight: ${theme.typography.body2.fontWeight}
  `}
  white-space: nowrap;
`;

const StyledBox = styled(Box)`
  white-space: nowrap;
  padding-left: 1;
`;

export default function PartsCatalogueFooter() {
  const { enabledFeatures } = useTenant();
  const configManagement = enabledFeatures.includes('configuration-management');
  const canSeeButtons = useUserHasRole(allowedRoles) && configManagement;

  return (
    <StyledContainer>
      {canSeeButtons && (
        <>
          <StyledLink href={knowledgeBase} target="_blank" rel="noopener noreferrer">
            {t('navigation:knowledgeBase')}
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </StyledLink>
          <Divider orientation="vertical" flexItem />
          <StyledLink href={raiseTicket} target="_blank" rel="noopener noreferrer">
            {t('navigation:reportAnIssue')}
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </StyledLink>
        </>
      )}

      <StyledBox>
        {t('navigation:poweredBy')}&nbsp;
        <StyledA href={baseUrl} target="_blank" rel="noopener noreferrer">
          Partful
        </StyledA>
      </StyledBox>
    </StyledContainer>
  );
}
